import React from 'react';

export const EntraAuthPath = '/entra-auth';

// Intentionally trivial: the Microsoft popup redirects here so the opener can
// read the #code=... fragment. This route must NOT navigate, redirect, or sit
// behind the auth guard, or the fragment is stripped before MSAL reads it
// (causing BrowserAuthError: block_nested_popups / user_cancelled).
function EntraAuth() {
    return <div>Completing sign-in…</div>;
}

export default EntraAuth;
